import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const VouchersQuery = gql`
    query($groupId: String!) {
        vouchers(groupId: $groupId) {
            id
            title
            pohodaIDS
            active
            actualUsage
            usageLimit
            validFrom
            validTo
            amountValue
            customerId
        }

        voucherGroup(voucherGroupId: $groupId) {
            id
            title
        }
    }
`;

const CreateVoucherMutation = gql`
    mutation($pohodaIDS: String, $voucherGroupId: String!, $voucher: VoucherInput!) {
        createVoucher(pohodaIDS: $pohodaIDS, voucherGroupId: $voucherGroupId, voucher: $voucher) {
            id
        }
    }
`;

const UpdateVoucherMutation = gql`
    mutation($id: String!, $voucher: VoucherInput!, $pohodaIDS: String) {
        updateVoucher(id: $id, pohodaIDS: $pohodaIDS, voucher: $voucher) {
            id
        }
    }
`;

const DeleteVoucherMutation = gql`
    mutation($id: String!) {
        deleteVoucher(id: $id) {
            id
        }
    }
`;

interface IInputProps {
    children?: any;
    voucherGroupId: string;
}

interface Response {
    data: any;
}

class GetVouchersQuery extends React.Component<ChildProps<IInputProps, Response>, {}> {
    render() {
        const { vouchers, createVoucher, updateVoucher, deleteVoucher }: any = this.props;
        return this.props.children({
            vouchers,
            createVoucher,
            updateVoucher,
            deleteVoucher
        });
    }
}

export default compose(
    graphql<IInputProps, Response>(VouchersQuery, {
        name: 'vouchers',
        options: props => ({
            variables: {
                groupId: props.voucherGroupId
            },
            fetchPolicy: 'network-only'
        })
    }),
    graphql<IInputProps, Response>(CreateVoucherMutation, {
        name: 'createVoucher'
    }),
    graphql<IInputProps, Response>(UpdateVoucherMutation, {
        name: 'updateVoucher'
    }),
    graphql<IInputProps, Response>(DeleteVoucherMutation, {
        name: 'deleteVoucher'
    })
)(GetVouchersQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Vouchers/Vouchers.tsx